import Vue from 'vue';
import Axios from 'axios';
import Router from "vue-router";
import format from 'date-fns/format';

import './plugins/vuetify';
import App from './App.vue';
import store from './store';
import routes from './routes';

import DefaultLayout from '@/layouts/defaultLayout';
import LoginLayout from '@/layouts/loginLayout';

Vue.config.productionTip = false;
Vue.component('default-layout', DefaultLayout);
Vue.component('login-layout', LoginLayout);

Vue.use(Router);
Vue.filter('formatDate', function(value, formatStr) {
  if (value) {
    return format(value, formatStr)
  }
});

const router = new Router({
  mode: 'history',
  routes,
});

Vue.prototype.$http = Axios;
const token = localStorage.getItem('token');
if (token) {
  Vue.prototype.$http.defaults.headers.common.Authorization = Vue.prototype.$http.defaults.headers.common.Authorization = `Bearer : ${token}`;
}
router.beforeEach((to, from, next) => {
  if (to.meta.withoutAuth === true) return next();
  if (store.getters.user) return next();
  return next('/login');
});



new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
